import { render } from "./CASIQuestionsSection.vue?vue&type=template&id=7071e5df&scoped=true"
import script from "./CASIQuestionsSection.vue?vue&type=script&lang=js"
export * from "./CASIQuestionsSection.vue?vue&type=script&lang=js"

import "./CASIQuestionsSection.vue?vue&type=style&index=0&id=7071e5df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7071e5df"]])

export default __exports__